module.exports = __webpack_public_path__ + "img/thantai-sad.c4b1051e.png";